mutation CreateConfig($input: CreateConfigInput!) {
  createConfig(input: $input) {
    id
  }
}
